<template>
  <div>
    <div class="top-intro">
      <div class="top-left">
        <p>
          本空气质量评估平台是基于北京大学<a
            href="https://songxichen.com/index.php/User"
          >
            陈松蹊团队</a
          >自2015年发布的空气质量系列报告的内容，整合汇总而成。
        </p>
        本平台对河北、河南、山东、山西、陕西、安徽、江苏、江西、内蒙古九省及北京、天津、上海三市
        <el-popover
          placement="top-start"
          trigger="hover"
          width="400"
          class="city-popover"
        >
          <slot>
            <h4>目前参与评估的九省三市共 113 个地级（及以上）城市如下</h4>
            <el-collapse accordion>
              <el-collapse-item
                v-for="prov in provs"
                :key="prov"
                :title="prov.prov + ' ' + prov.city.length + ' 个城市'"
              >
                <el-tag
                  type="text"
                  class="city"
                  v-for="city in prov.city"
                  :key="city"
                  >{{ city }}</el-tag
                >
              </el-collapse-item>
            </el-collapse>
          </slot>
          <el-button slot="reference"><strong>“3+110”城市</strong></el-button>
        </el-popover>
        自2013年或2014年（根据城市国控站点开始时间）季节空气质量的演变与评估。
        空气质量评估将针对六个常规大气污染物:
        PM<sub>2.5</sub>、PM<sub>10</sub>、二氧化硫（SO<sub>2</sub>）、一氧化碳（CO）、二氧化氮（NO<sub>2</sub>）和臭氧（O<sub>3</sub>）的<strong>季节平均</strong>浓度。
        评估方法采用陈松蹊团队提出的<strong>气象调整方法</strong>去除观测数据中的气象干扰和混杂影响，
        使得不同年的污染浓度可比，从而能及时衡量大气环境保护措施的效果。我们专门给出一个城市的<strong>人努力-天帮忙指数</strong>。
        <p>
          平台将提供各种维度的多城市（同省或跨省）的污染情况纵向（时间）和横向（不同城市）的比较页面，利于管理者和公众了解本城市和相邻城市的空气质量现状和变化。
          也给出每个城市的<strong>六个污染物的监视坐标</strong>，综合了解城市颗粒物以及气态污染物的污染状况。
        </p>

        <div>
          <span class="intro-title">本平台的主要评估内容如下：</span>
          <span
            class="intro-li"
            v-for="(cont, index) in assess_titles"
            :key="cont"
          >
            {{ index + 1 }}、{{ cont }}
          </span>
        </div>
      </div>
      <div class="top-right">
        <a
          href="https://songxichen.com/Uploads/Files/Report/Air_Quality_Assessment_Report_IX.pdf"
        >
          <el-image class="top-img" :src="src" fit="contain"></el-image>
        </a>
      </div>
    </div>

    <div class="flex-box">
      <div class="left">
        <!-- <el-row >
          <el-col :xs="12" :sm="12" :md="12" :lg="12" 
            ><div class="grid-content bg-purple"></div
          ></el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="12"
            ><div class="grid-content bg-purple-light"></div
          ></el-col>
          
        </el-row> -->

        <div
          id="platform-top-chart"
          :style="{ height: eleheight / 2 + 'px' }"
        ></div>
        <div
          id="platform-worse-chart"
          :style="{ height: eleheight / 2 + 'px' }"
        ></div>
      </div>
      <div class="right">
        <div
          id="platform-map-chart"
          :style="{ height: eleheight + 'px' }"
        ></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* ###################################################### */
/* 文字介绍部分 */
.top-intro {
  /* background-color: rgb(243, 241, 236); */
  /* color: #ececec; */
  text-align: justify;
  /* padding: 1px 20px; */
  /* text-indent: 2em; */
  line-height: 26px;
  max-width: 1440px;
  margin: auto;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-content: center;
  align-items: stretch;
  padding: 20px;
}

.top-left {
  flex: 2;
  align-self: center;
  min-width: 350px;
}

.top-right {
  flex: 1;
  padding-left: 20px;
  min-width: 300px;
  max-height: 400px;
}
.top-img {
  padding-left: 25px;
  height: 100%;
}

.city-popover button {
  padding: 0;
  border: 0;
  font-size: 16px;
  color: #4169e1;
  background: transparent;
}

.city {
  /* padding: 1px 10px 1px 0; */
  /* color: #4169e1; */
  background: transparent;
  border: none;
  /* margin-left: 0 !important; */
  /* text-decoration: none !important; */
}
/* ###################################################### */
/* 图表部分 */
.flex-box {
  display: flex;
  flex-flow: row wrap-reverse;
  justify-content: center;
  align-content: center;
  align-items: stretch;
  max-width: 1440px;
  margin: 0 auto;
  padding-bottom: 20px;
}

/* 左边部分 */
.left {
  /* width: 30%; */
  flex: 2;
  min-width: 350px;
}

/* 右边地图部分 */
.right {
  flex: 2;
  /* width: 100%; */
  min-width: 350px;
  padding: 0 20px;
}
</style>

<script>
import { getPullStand } from "@/assets/js/my-utils.js";

export default {
  name: "Platform",
  data() {
    return {
      eleheight: 560,
      chart: [],
      src: require("@/assets/report_pic10.png"),
      assess_titles: [
        "气象调整前后污染物各季度浓度变化",
        "经气象调整后各污染物超标情况",
        "经气象调整后各污染物浓度下降情况",
        "各城市“人努力-天帮忙”指数",
      ],
      assessPull: "PM2.5",
      assessYear: "2022",
      assessSeason: "4",
      provs: [],
      cities: [],
      cities_zh: [],
    };
  },
  created() {
    const that = this;
    // 获取城市
    this.$axios
      .post("/AQAssess/getData.php", {
        database: "cities",
      })
      .then((res) => {
        // let cities = res.data;
        that.cities = res.data;

        that.cities.forEach((element) => {
          let add = false;
          for (let i = 0; i < that.provs.length; i++) {
            if (that.provs[i].prov == element[0]) {
              that.provs[i].city.push(element[1]);
              add = true;
              break;
            }
          }
          if (!add) {
            that.provs.push({
              prov: element[0],
              city: [element[1]],
            });
          }

          that.cities_zh.push(element[1] + "市");
        });
      })
      .catch((e) => {
        this.$message({
          type: "info",
          message: "获取城市数据失败",
        });
      });
  },
  methods: {
    getColorByAdcode(adcode) {
      let colors = [
        "#DC143C",
        "#C71585",
        "#7B68EE",
        "#3CB371",
        "#FFA500",
        "#FF4500",
        "#808080",
        "#d48265",
      ];

      if (adcode == 110000) {
        return "#3CB371";
      } else if (adcode == 120000) {
        return "#3CB371";
      } else if (adcode == 310000) {
        return "#3CB371";
      } else if (adcode == 130000) {
        // 河北省
        return "#FFA500";
      } else if (adcode == 140000) {
        // 山西省
        return "#FF4500";
      } else if (adcode == 150000) {
        // 内蒙
        return "#808080";
      } else if (adcode == 320000) {
        // 江苏
        return "#d48265";
      } else if (adcode == 340000) {
        // 安徽
        return "#DC143C";
      } else if (adcode == 360000) {
        // 江西
        return "#C71585";
      } else if (adcode == 370000) {
        // 山东省
        return "#7B68EE";
      } else if (adcode == 410000) {
        // 河南省
        return "#3CB371";
      } else if (adcode == 610000) {
        // 陕西省
        return "#FFA500";
      }

      return "";
    },
    initPro() {
      // dep = 1 表示市级
      let depth = 1;
      var disProvince;
      var that = this;

      disProvince && disProvince.setMap(null);

      disProvince = new AMap.DistrictLayer.Province({
        zIndex: 12,
        adcode: [
          110000, // 北京
          120000, // 天津市
          130000, // 河北省
          140000, // 山西省
          150000, // 内蒙古自治区
          310000, // 上海市
          320000, // 江苏省
          340000, // 安徽省
          360000, // 江西省
          370000, // 山东省
          410000, // 河南省
          610000, // 陕西省
        ],
        depth: depth,
        opacity: 0.2,
        styles: {
          fill: function (properties) {
            // properties为可用于做样式映射的字段，包含
            // NAME_CHN:中文名称
            // adcode_pro
            // adcode_cit
            // adcode
            let adcode_pro = properties.adcode_pro;

            let NAME_CHN = properties.NAME_CHN;
            if (that.cities_zh.indexOf(NAME_CHN) != -1) {
              return that.getColorByAdcode(adcode_pro);
            }

            return "";
          },
          "province-stroke": "cornflowerblue",
          "city-stroke": "white", // 中国地级市边界
          "county-stroke": "rgba(255,255,255,0.5)", // 中国区县边界
        },
      });

      disProvince.setMap(this.map);
    },

    getPullMapsData() {
      this.$axios
        .post("/AQAssess/getData.php", {
          database: "area_pull",
          pull: this.assessPull,
          year: this.assessYear,
          season: this.assessSeason,
        })
        .then((res) => {
          // console.log(res.data);
          let top10 = [];
          let worse10 = [];
          for (let i = 0; i < 12; i++) {
            top10.push(res.data[i]);
            worse10.push(res.data[res.data.length - i - 1]);
          }

          // console.log(top10);
          // console.log(worse10);

          // // console.log(that.pulldata);
          let seasonZh = ["春", "夏", "秋", "冬"];
          this.drawTopBarCharts(
            this.chart[0],
            top10,
            this.assessPull,
            this.assessYear + seasonZh[this.assessSeason - 1],
            "top"
          );

          this.drawTopBarCharts(
            this.chart[1],
            worse10,
            this.assessPull,
            this.assessYear + seasonZh[this.assessSeason - 1],
            "worse"
          );
        });
      // .catch((e) => {
      //   this.$message({
      //     type: "info",
      //     message: "获取" + this.cityname + "数据失败",
      //   });
      // });
    },
    drawTopBarCharts(chart, data, pull, time, type) {
      let title = time + '"2+66"城市';
      if (-1 != ["PM2.5", "PM10", "SO2", "NO2", "CO", "O3"].indexOf(pull)) {
        title = time + pull;
        if (type == "top") {
          title = title + "浓度最低的" + data.length + "个城市";
        } else {
          title = title + "浓度最高的" + data.length + "个城市";
        }
      }
      let draw_data = [];
      data.forEach((element) => {
        draw_data.unshift([
          parseFloat(element[1]).toFixed(2),
          element[0],
          element[2],
        ]);
      });

      let option = {
        title: {
          text: title,
          // subtext: title,
          padding: [
            5, // 上
            10, // 右
            5, // 下
            10, // 左
          ],
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            let text = time + pull + "浓度：" + "<br>";
            params.forEach((param) => {
              text =
                text +
                param.marker +
                param.data[1] +
                "：" +
                param.data[0] +
                getPullStand(pull) +
                "<br>" +
                param.marker +
                "排名：" +
                param.data[2];
            });
            return text;
          },
        },
        grid: {
          left: 20,
          right: 40,
          bottom: 28,
          top: 28,
          containLabel: true,
        },
        xAxis: {
          type: "value",
          name: getPullStand(pull),
          nameGap: -30,
          // boundaryGap: ["20%", "20%"],
          boundaryGap: [0, 0.01],
          nameTextStyle: {
            padding: [60, 0, 0, 0],
          },
        },
        yAxis: {
          type: "category",
          axisLabel: {
            interval: 0,
          },
        },
        series: [
          {
            type: "bar",
            data: draw_data,
            color: type == "top" ? "#5bd75b" : "#E6A23C",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(220, 220, 220, 0.8)",
            },
            label: {
              // show: true,
              position: "right",
              color: "red",
              formatter: function (params) {
                return "#" + params.data[2];
                // return "#" + params.data[0];
              },
            },
          },
        ],
      };
      chart.setOption(option);
      chart.hideLoading();
    },

    drawPlatformCharts() {
      this.map = new AMap.Map("platform-map-chart", {
        zoom: 5,
        center: [112, 35],
        pitch: 0,
        viewMode: "3D",
      });

      this.initPro();
    },
  },
  mounted() {
    this.chart.push(
      this.$echarts.init(document.getElementById("platform-top-chart"))
    );

    this.chart.push(
      this.$echarts.init(document.getElementById("platform-worse-chart"))
    );

    this.chart.forEach((element) => {
      element.showLoading();
    });

    const that = this;
    this.getPullMapsData();
    let index = 0;
    let pulls = ["PM2.5", "PM10", "SO2", "NO2", "CO", "O3"];

    // 绘制地图图
    this.drawPlatformCharts();

    setInterval(() => {
      index = (index + 1) % 6;
      if (index < 6) {
        that.assessPull = pulls[index];
      }
      that.getPullMapsData();
    }, 10000);

    window.addEventListener("resize", () => {
      that.chart.forEach((element) => {
        element.resize();
      });
    });
  },
  components: {},
};
</script>
